// ===== DATE DE EDITAT =====
  // Pune clipurile în folderul "clipuri" și scrie aici numele fișierelor.
  const DATA = JSON.parse(document.getElementById("ss-data").textContent);
  const CLIPS = [
    { src: "https://cdn.shopify.com/videos/c/vp/1c16a6f31b2242f4b535ac4073df65b4/1c16a6f31b2242f4b535ac4073df65b4.SD-480p-1.5Mbps-97963232.mp4", hd: "https://cdn.shopify.com/videos/c/vp/1c16a6f31b2242f4b535ac4073df65b4/1c16a6f31b2242f4b535ac4073df65b4.HD-720p-4.5Mbps-97963232.mp4", title: "Peste 100.000 lei generați", stat: "Peste 100.000 lei generați doar cu acest clip", g: ["#4a1d14", "#121214"] },
    { src: "https://cdn.shopify.com/videos/c/vp/36b13670cafe4d1dad070b7c67f70181/36b13670cafe4d1dad070b7c67f70181.SD-480p-1.5Mbps-97963234.mp4", hd: "https://cdn.shopify.com/videos/c/vp/36b13670cafe4d1dad070b7c67f70181/36b13670cafe4d1dad070b7c67f70181.HD-720p-4.5Mbps-97963234.mp4", title: "", g: ["#1d2a4a", "#121214"] },
    { src: "https://cdn.shopify.com/videos/c/vp/786185d5fc654786858015e86b626dd7/786185d5fc654786858015e86b626dd7.SD-480p-1.5Mbps-97963233.mp4", hd: "https://cdn.shopify.com/videos/c/vp/786185d5fc654786858015e86b626dd7/786185d5fc654786858015e86b626dd7.HD-720p-4.5Mbps-97963233.mp4", title: "", g: ["#3d3a12", "#121214"] },
    { src: "https://cdn.shopify.com/videos/c/vp/faf486535dfc46f19052d50b69ac7e37/faf486535dfc46f19052d50b69ac7e37.SD-480p-1.5Mbps-97968596.mp4", hd: "https://cdn.shopify.com/videos/c/vp/faf486535dfc46f19052d50b69ac7e37/faf486535dfc46f19052d50b69ac7e37.HD-720p-4.5Mbps-97968596.mp4", title: "", g: ["#16382c", "#121214"] },
    { src: "https://cdn.shopify.com/videos/c/vp/ae33cdac2d9f46339ce3dc1ad0993d7a/ae33cdac2d9f46339ce3dc1ad0993d7a.SD-480p-1.5Mbps-97968597.mp4", hd: "https://cdn.shopify.com/videos/c/vp/ae33cdac2d9f46339ce3dc1ad0993d7a/ae33cdac2d9f46339ce3dc1ad0993d7a.HD-720p-4.5Mbps-97968597.mp4", title: "", g: ["#3a1638", "#121214"] },
    { src: "https://cdn.shopify.com/videos/c/vp/2cf2abd52ba14fdabbf733843c7d9c26/2cf2abd52ba14fdabbf733843c7d9c26.SD-480p-1.5Mbps-97968598.mp4", hd: "https://cdn.shopify.com/videos/c/vp/2cf2abd52ba14fdabbf733843c7d9c26/2cf2abd52ba14fdabbf733843c7d9c26.HD-720p-4.5Mbps-97968598.mp4", title: "", g: ["#4a2a14", "#121214"] },
    { src: "https://cdn.shopify.com/videos/c/vp/107397c4e3594052a840e2b737a1e2a5/107397c4e3594052a840e2b737a1e2a5.SD-480p-1.5Mbps-97968595.mp4", hd: "https://cdn.shopify.com/videos/c/vp/107397c4e3594052a840e2b737a1e2a5/107397c4e3594052a840e2b737a1e2a5.HD-720p-4.5Mbps-97968595.mp4", title: "", g: ["#14354a", "#121214"] },
    { src: "https://cdn.shopify.com/videos/c/vp/fb4fff05bce440d2a189a32a5aa1b6be/fb4fff05bce440d2a189a32a5aa1b6be.SD-480p-1.5Mbps-97968861.mp4", hd: "https://cdn.shopify.com/videos/c/vp/fb4fff05bce440d2a189a32a5aa1b6be/fb4fff05bce440d2a189a32a5aa1b6be.HD-720p-4.5Mbps-97968861.mp4", title: "", g: ["#2e1a4a", "#121214"] },
  ];

  // Creatorii din demo-ul de dashboard: pune la „img” link-ul pozei (ex. din Shopify → Conținut → Fișiere)
  const DEMO_CREATORS = [
    { name: "Ana", age: 24, style: "Energică, vorbește direct", niches: ["Beauty", "Fashion"], img: "https://cdn.shopify.com/s/files/1/1116/3464/5331/files/0aa420cb9f914845ad028d2d36bf4798.webp?width=480", g: "#8e8e93" },
    { name: "Bianca", age: 26, style: "Caldă, ca o prietenă", niches: ["Casă", "Lifestyle"], img: "https://cdn.shopify.com/s/files/1/1116/3464/5331/files/c1a72d86ec3a49b7b9b25775d04911fa.webp?width=480", g: "#8e8e93" },
    { name: "Ioana", age: 23, style: "Amuzantă, spontană", niches: ["Tech", "Gadgeturi"], img: "https://cdn.shopify.com/s/files/1/1116/3464/5331/files/916e218a3bbf4acb8f635c4d24dade2b.webp?width=480", g: "#8e8e93" },
  ];

  // Reclamele din demo-ul de dashboard (secțiunea „Platforma”)
  const DEMO_ADS = [
    { src: "https://cdn.shopify.com/videos/c/vp/4f599f221f4b4a2d9ceee7da6649b92b/4f599f221f4b4a2d9ceee7da6649b92b.SD-480p-1.5Mbps-97987734.mp4", hd: "https://cdn.shopify.com/videos/c/vp/4f599f221f4b4a2d9ceee7da6649b92b/4f599f221f4b4a2d9ceee7da6649b92b.HD-720p-4.5Mbps-97987734.mp4", title: "", name: "Reclama 1 · baterie Apple", g: ["#121214", "#121214"] },
    { src: "https://cdn.shopify.com/videos/c/vp/3c6d670652ef468cb564b0789f0a6a25/3c6d670652ef468cb564b0789f0a6a25.SD-480p-1.5Mbps-97987848.mp4", hd: "https://cdn.shopify.com/videos/c/vp/3c6d670652ef468cb564b0789f0a6a25/3c6d670652ef468cb564b0789f0a6a25.HD-720p-4.5Mbps-97987848.mp4", title: "", name: "Reclama 2 · baterie Apple", g: ["#121214", "#121214"] },
  ];

  // ==========================

  // Imaginea de previzualizare făcută de Shopify pentru fiecare clip (~40 KB), afișată până se încarcă video-ul
  const posterOf = (clip, w) => {
    const id = (clip.src.match(/videos\/c\/vp\/([a-f0-9]+)\//) || [])[1];
    return id ? `https://cdn.shopify.com/s/files/1/1116/3464/5331/files/preview_images/${id}.thumbnail.0000000000.jpg?width=${w}` : "";
  };

  // Lazy load: clipurile cu autoplay pornesc doar când ajung pe ecran și se opresc când ies
  const lazyIO = new IntersectionObserver(entries => entries.forEach(({ target: v, isIntersecting }) => {
    if (isIntersecting) {
      if (!v.getAttribute("src")) v.src = v.dataset.src;
      v.play().catch(() => {});
    } else if (!v.paused) v.pause();
  }), { rootMargin: "200px" });

  function videoEl(clip, { autoplay = false, tag = true, hd = false, lazy = true } = {}) {
    const box = document.createElement("div");
    box.className = "vid";
    box.style.setProperty("--g1", clip.g[0]);
    box.style.setProperty("--g2", clip.g[1]);
    const poster = posterOf(clip, hd ? 720 : 360);
    if (!poster) box.innerHTML = `<div class="vid-ph"><div><div class="play"></div>Clipul tău aici</div></div>`;
    const v = document.createElement("video");
    // muted + playsinline înainte de src, altfel iPhone-ul nu pornește clipul singur
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
    v.setAttribute("muted", ""); v.setAttribute("playsinline", "");
    if (poster) v.poster = poster;
    v.preload = "none";
    v.dataset.src = hd && clip.hd ? clip.hd : clip.src;
    const ready = () => box.querySelector(".vid-ph")?.remove();
    v.addEventListener("loadeddata", ready);
    v.addEventListener("playing", ready);
    box.prepend(v);
    if (!lazy) { v.src = v.dataset.src; v.preload = "auto"; if (autoplay) v.play().catch(() => {}); }
    else if (autoplay) lazyIO.observe(v);
    // fără autoplay: video-ul se încarcă abia la hover sau la click (vezi portofoliul)
    if (tag && clip.title) box.insertAdjacentHTML("beforeend", `<div class="vid-tag">${clip.title}</div>`);
    return box;
  }

  // Wave dividers (val animat între secțiuni)
  const WAVE_COLORS = { light: "#f3efe6", dark: "#0f0f0e", orange: "#ff4d2e" };
  const WAVE_A = ["M0,40 C160,80 320,20 480,50 C640,80 800,30 960,55 C1120,80 1280,25 1440,50 C1600,75 1760,35 1920,50 L1920,100 L0,100 Z",
                  "M0,55 C160,25 320,75 480,45 C640,20 800,70 960,40 C1120,20 1280,70 1440,45 C1600,25 1760,65 1920,45 L1920,100 L0,100 Z",
                  "M0,45 C160,70 320,30 480,55 C640,85 800,25 960,50 C1120,75 1280,30 1440,55 C1600,80 1760,30 1920,55 L1920,100 L0,100 Z"];
  const WAVE_B = ["M0,50 C200,20 400,75 600,45 C800,20 1000,70 1200,45 C1400,20 1600,70 1920,40 L1920,100 L0,100 Z",
                  "M0,35 C200,70 400,30 600,60 C800,85 1000,35 1200,60 C1400,80 1600,30 1920,55 L1920,100 L0,100 Z",
                  "M0,60 C200,30 400,80 600,50 C800,25 1000,75 1200,50 C1400,25 1600,75 1920,45 L1920,100 L0,100 Z"];
  const still = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const wavePath = (frames, dur, fill, opacity) => `<path d="${frames[0]}" fill="${fill}" opacity="${opacity}">${still ? "" :
    `<animate attributeName="d" dur="${dur}" repeatCount="indefinite" calcMode="spline" keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1" values="${[...frames, frames[0]].join(";")}"/>`}</path>`;
  document.querySelectorAll(".wave").forEach(w => {
    const from = WAVE_COLORS[w.dataset.from], to = WAVE_COLORS[w.dataset.to];
    w.style.background = from;
    w.innerHTML = `<svg viewBox="0 0 1920 100" preserveAspectRatio="none" aria-hidden="true">${wavePath(WAVE_B, "4s", to, .5)}${wavePath(WAVE_A, "6s", to, 1)}</svg>`;
  });

  // Ad mixer: trece prin toate cele 5 x 5 x 5 = 125 de combinații
  const mixLists = {};
  document.querySelectorAll("#mixer ol").forEach(ol => {
    const k = ol.dataset.k, pre = k.toUpperCase();
    ol.innerHTML = [1, 2, 3, 4, 5].map(n => `<li><b>${pre}${n}</b></li>`).join("");
    mixLists[k] = [...ol.children];
  });
  let mixI = 0, mixTimer = null;
  function mixShow(i) {
    const h = Math.floor(i / 25), b = Math.floor(i / 5) % 5, c = i % 5;
    [["h", h], ["b", b], ["c", c]].forEach(([k, n]) => mixLists[k].forEach((li, j) => li.classList.toggle("on", j === n)));
    document.getElementById("mixH").textContent = `H${h + 1}`;
    document.getElementById("mixB").textContent = `B${b + 1}`;
    document.getElementById("mixC").textContent = `C${c + 1}`;
    document.getElementById("mixNum").textContent = "#" + (i + 1);
    document.getElementById("mixTotal").textContent = i + 1;
  }
  function mixTick() {
    mixShow(mixI);
    if (mixI === 124) { mixI = 0; mixTimer = setTimeout(mixTick, 3500); return; }
    // începe încet, ca să se vadă cum se schimbă piesele, apoi accelerează
    const delay = mixI < 6 ? 700 : mixI < 15 ? 260 : 55;
    mixI++;
    mixTimer = setTimeout(mixTick, delay);
  }
  if (still) { mixShow(124); }
  else {
    mixShow(0);
    new IntersectionObserver(([e]) => {
      clearTimeout(mixTimer);
      if (e.isIntersecting) { mixI = 0; mixTick(); }
    }, { threshold: .35 }).observe(document.getElementById("mixer"));
  }

  // Vizualizare clipuri: click pe telefon sau pe portofoliu -> fereastră mare, cu sunet, cu anterior/următor
  const modal = document.getElementById("modal"), modalBox = document.getElementById("modalBox");
  let VIEWABLE = CLIPS.filter(c => c.hd);
  let current = 0;
  function showClip(i) {
    current = (i + VIEWABLE.length) % VIEWABLE.length;
    modalBox.innerHTML = "";
    const big = videoEl(VIEWABLE[current], { autoplay: true, tag: false, hd: true, lazy: false });
    const bv = big.querySelector("video"); bv.muted = false; bv.controls = true;
    modalBox.appendChild(big);
    const many = VIEWABLE.length > 1;
    document.getElementById("modalPrev").hidden = document.getElementById("modalNext").hidden = !many;
    document.getElementById("modalCount").textContent = many ? `${current + 1} / ${VIEWABLE.length}` : "";
  }
  function openClip(c, list = CLIPS.filter(x => x.hd)) {
    if (!c.hd) return;
    VIEWABLE = list;
    showClip(VIEWABLE.indexOf(c));
    modal.classList.add("open");
    document.body.classList.add("locked");
  }
  const closeModal = () => { modal.classList.remove("open"); modalBox.innerHTML = ""; document.body.classList.remove("locked"); };
  document.getElementById("modalClose").onclick = closeModal;
  document.getElementById("modalPrev").onclick = () => showClip(current - 1);
  document.getElementById("modalNext").onclick = () => showClip(current + 1);
  modal.addEventListener("click", e => { if (e.target === modal) closeModal(); });
  document.addEventListener("keydown", e => {
    if (!modal.classList.contains("open")) return;
    if (e.key === "Escape") closeModal();
    if (e.key === "ArrowLeft") showClip(current - 1);
    if (e.key === "ArrowRight") showClip(current + 1);
  });

  // Hero phones
  const phones = document.getElementById("heroPhones");
  // interfață ca pe TikTok peste fiecare telefon (like-uri, comentarii, cont), ca reclamele să arate native
  const ICON = {
    heart: '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.6-10-9.3C.4 8.4 2.3 4.5 6 4.1c2.2-.2 3.8 1 6 3.1 2.2-2.1 3.8-3.3 6-3.1 3.7.4 5.6 4.3 4 7.6C19.5 16.4 12 21 12 21z"/></svg>',
    chat: '<svg viewBox="0 0 24 24"><path d="M12 3C6.5 3 2 6.8 2 11.5c0 2.4 1.2 4.6 3.1 6.1L4.5 21l4-2c1.1.3 2.3.5 3.5.5 5.5 0 10-3.8 10-8.5S17.5 3 12 3z"/></svg>',
    share: '<svg viewBox="0 0 24 24"><path d="M13 4v4C6 9 3 13.5 2 19c2.5-3.5 6-5 11-5v4l9-7-9-7z"/></svg>',
  };
  const TT = [
    { user: "@magazinultau", text: "Comandă acum, livrare în 24h 📦" },
    { user: "@magazinultau", text: "Reclama ta, filmată de un om real" },
    { user: "@magazinultau", text: "Link în bio · stoc limitat" },
  ];
  [CLIPS[1], CLIPS[0], CLIPS[2]].forEach((c, i) => {
    const p = document.createElement("div");
    p.className = "phone";
    p.appendChild(videoEl(c, { autoplay: true, tag: false, lazy: false }));
    const t = TT[i];
    p.insertAdjacentHTML("beforeend", `<div class="tt" aria-hidden="true">
      <div class="tt-side"><span class="av">M</span><i>${ICON.heart}</i><i>${ICON.chat}</i><i>${ICON.share}</i></div>
      <div class="tt-bot"><b>${t.user}</b>${t.text}<br><span>Sponsorizat</span></div></div>`);
    if (c.hd) {
      p.tabIndex = 0;
      p.setAttribute("role", "button");
      p.setAttribute("aria-label", "Vezi clipul cu sunet");
      p.insertAdjacentHTML("beforeend", `<span class="tap">▶ Vezi cu sunet</span>`);
      p.addEventListener("click", () => openClip(c));
      p.addEventListener("keydown", e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openClip(c); } });
    }
    phones.appendChild(p);
  });
  // insigna se adaugă după telefoane, ca să nu strice ordinea lor (.phone:nth-child)
  const starClip = CLIPS.find(c => c.stat);
  if (starClip) {
    const b = document.createElement("div");
    b.className = "phone-badge";
    b.innerHTML = `<strong>100.000+ lei</strong><span>generați doar cu acest clip</span>`;
    b.addEventListener("click", () => openClip(starClip));
    phones.appendChild(b);
  }

  // Demo dashboard client: 4 ecrane care se schimbă singure până când vizitatorul apasă ceva
  (() => {
    const app = document.getElementById("demoApp");
    if (!app) return;
    const logo = document.querySelector("#nav .logo svg");
    if (logo) document.getElementById("demoLogo").appendChild(logo.cloneNode(true));

    // 0. alegi creatorul (interactiv)
    const crBox = document.getElementById("demoCreators");
    let crPick = 0;
    function renderCreators() {
      crBox.innerHTML = DEMO_CREATORS.map((c, i) => `<button type="button" class="demo-cr${i === crPick ? " on" : ""}" data-i="${i}" aria-pressed="${i === crPick}">
        <div class="ph${c.img ? " img" : ""}" style="${c.img ? `background-image: url('${c.img}')` : `--g: ${c.g}`}">${c.name[0]}</div>
        <span class="chk">${i === crPick ? "✓" : ""}</span>
        <div class="info"><b>${c.name}, ${c.age}</b><span>${c.style}</span><div class="tags">${c.niches.map(n => `<em>${n}</em>`).join("")}</div></div>
      </button>`).join("");
      document.getElementById("demoPick").innerHTML = `<span>Ai ales: <b>${DEMO_CREATORS[crPick].name}</b> · ScrollStop Growth · 64 reclame</span><span class="go">Continuă →</span>`;
    }
    crBox.addEventListener("click", e => {
      const b = e.target.closest(".demo-cr");
      if (!b) return;
      stopAuto();
      crPick = Number(b.dataset.i);
      renderCreators();
    });
    renderCreators();

    // 1. comanda trece prin statusuri
    const STEPS = ["Brief primit", "Produs expediat", "Produs primit", "Script", "Filmare", "Editare", "Livrat"];
    const FEED = ["Brief primit · creator ales, ne apucăm de lucru", "Ai expediat produsul · AWB Sameday", "Am primit produsul", "Ai aprobat script-urile", "Filmăm cu creatorul ales"];
    const track = document.getElementById("demoTrack");
    track.innerHTML = STEPS.map(x => `<div>${x}</div>`).join("");
    let stepTimer = null;
    function playTrack() {
      clearTimeout(stepTimer);
      let i = 0;
      const tick = () => {
        [...track.children].forEach((d, j) => { d.classList.toggle("done", j <= i); d.classList.toggle("now", j === i); });
        document.getElementById("demoBadge").textContent = STEPS[i];
        document.getElementById("demoFilm").textContent = i === 4 ? 1 : 0;
        document.getElementById("demoFeed").innerHTML = FEED.slice(0, i + 1).reverse().slice(0, 3).map(x => `<div>${x.replace("creatorul ales", DEMO_CREATORS[crPick].name)}</div>`).join("");
        if (i < 4) { i++; stepTimer = setTimeout(tick, still ? 0 : 1000); }
      };
      tick();
    }

    // 2. script-uri de aprobat (interactiv)
    const SCR = {
      Hook: [["Am încercat 5 perechi de căști. Doar una a rămas.", "approved"], ["Nu mai cumpăra căști până nu vezi asta.", "approved"], ["De ce nu mai port căști cu fir de un an.", "pending"]],
      Body: [["Se conectează în 2 secunde, țin 30 de ore și nu-mi cad nici la sală.", "approved"], ["Le-am testat o lună: la birou, în metrou, la alergat.", "declined", "Mai scurt, fără partea cu metroul."], ["Sunetul e clar, iar carcasa încape în orice buzunar.", "pending"]],
      CTA: [["Intră pe site, au -20% doar săptămâna asta.", "approved"], ["Link-ul e în bio, livrarea e gratuită.", "pending"], ["Comandă azi și le ai mâine acasă.", "pending"]],
    };
    const LBL = { approved: "Aprobat", declined: "Refuzat", pending: "Așteaptă aprobarea" };
    const scrBox = document.getElementById("demoScripts");
    function renderScripts() {
      scrBox.innerHTML = Object.entries(SCR).map(([k, list]) => `<div class="demo-col"><h5>${k} <small>${list.filter(x => x[1] === "approved").length}/${list.length} aprobate</small></h5>
        ${list.map(([t, st, note], i) => `<div class="demo-scr ${st}"><div class="st"><span>${k} ${i + 1}</span><em>${LBL[st]}</em></div>${t}
          ${st === "declined" && note ? `<div class="note">Motivul tău: ${note}</div>` : ""}
          <div class="acts"><button type="button" class="yes${st === "approved" ? " on" : ""}" data-k="${k}" data-i="${i}" data-st="approved">✓ Aprob</button><button type="button" class="no${st === "declined" ? " on" : ""}" data-k="${k}" data-i="${i}" data-st="declined">✕ Refuz</button></div></div>`).join("")}</div>`).join("");
    }
    scrBox.addEventListener("click", e => {
      const b = e.target.closest("button[data-st]");
      if (!b) return;
      stopAuto();
      const it = SCR[b.dataset.k][b.dataset.i];
      it[1] = it[1] === b.dataset.st ? "pending" : b.dataset.st;
      if (it[1] === "declined" && !it[2]) it[2] = "Hai să încercăm o variantă mai directă.";
      renderScripts();
    });
    renderScripts();

    // 3. reclamele livrate = clipurile reale din portofoliu
    const ads = document.getElementById("demoAds");
    DEMO_ADS.forEach((c, i) => {
      const a = document.createElement("div");
      a.className = "demo-ad"; a.tabIndex = 0; a.setAttribute("role", "button"); a.setAttribute("aria-label", `Vezi reclama ${i + 1}`);
      a.innerHTML = `<div class="pic" style="background-image: url('${posterOf(c, 240)}')"></div><small>${c.name} <b>↓</b></small>`;
      // player propriu în card: fără meniul browserului (fără „Descarcă”), fără click dreapta; un singur clip pornit o dată
      const pic = a.querySelector(".pic");
      let v = null;
      const ui = document.createElement("div");
      ui.className = "dp-ui";
      ui.innerHTML = `<button type="button" class="dp-play" aria-label="Pornește"></button><button type="button" class="dp-snd" aria-label="Fără sunet"></button><div class="dp-bar"><i></i></div>`;
      const setIcons = () => {
        ui.querySelector(".dp-play").innerHTML = v && !v.paused ? '<svg viewBox="0 0 24 24"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>' : '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
        ui.querySelector(".dp-snd").innerHTML = v && v.muted ? '<svg viewBox="0 0 24 24"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9l4 6M21 9l-4 6" stroke="currentColor" stroke-width="2" fill="none"/></svg>' : '<svg viewBox="0 0 24 24"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
      };
      const play = () => {
        stopAuto();
        if (!v) {
          v = document.createElement("video");
          v.src = c.hd || c.src; v.poster = posterOf(c, 240);
          v.playsInline = true; v.setAttribute("playsinline", ""); v.loop = true;
          v.disablePictureInPicture = true; v.setAttribute("controlslist", "nodownload noplaybackrate noremoteplayback");
          v.addEventListener("contextmenu", e => e.preventDefault());
          v.addEventListener("play", () => { ads.querySelectorAll("video").forEach(x => x !== v && x.pause()); a.classList.add("playing"); setIcons(); });
          v.addEventListener("pause", () => { a.classList.remove("playing"); setIcons(); });
          v.addEventListener("timeupdate", () => { ui.querySelector(".dp-bar i").style.width = (v.currentTime / v.duration * 100 || 0) + "%"; });
          pic.prepend(v);
          pic.appendChild(ui);
          pic.classList.add("on");
        }
        v.paused ? v.play().catch(() => {}) : v.pause();
      };
      pic.addEventListener("contextmenu", e => e.preventDefault());
      ui.addEventListener("click", e => e.stopPropagation());
      ui.querySelector(".dp-play").onclick = play;
      ui.querySelector(".dp-snd").onclick = () => { v.muted = !v.muted; setIcons(); };
      ui.querySelector(".dp-bar").onclick = e => { const r = e.currentTarget.getBoundingClientRect(); if (v.duration) v.currentTime = (e.clientX - r.left) / r.width * v.duration; };
      setIcons();
      a.addEventListener("click", play);
      a.addEventListener("keydown", e => { if (e.target === a && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); play(); } });
      ads.appendChild(a);
    });

    // tab-uri + derulare automată
    const tabs = [...document.querySelectorAll(".demo-tab")];
    const ORDER = tabs.map(t => t.dataset.view);
    const DUR = 7000;
    let cur = 0, auto = !still, autoTimer = null, started = false;
    document.querySelector(".demo-tabs").style.setProperty("--demo-t", DUR / 1000 + "s");
    function show(i) {
      cur = i;
      const v = ORDER[i];
      tabs.forEach((t, j) => { t.classList.toggle("on", j === i); t.setAttribute("aria-selected", j === i); t.classList.remove("run"); });
      if (auto) { void tabs[i].offsetWidth; tabs[i].classList.add("run"); }
      app.querySelectorAll(".demo-view").forEach(x => x.classList.toggle("on", x.dataset.view === v));
      app.querySelectorAll(".demo-sb a[data-nav]").forEach(a => a.classList.toggle("on", a.dataset.nav.split(" ").includes(v)));
      if (v === "track") playTrack();
      if (v !== "ads") ads.querySelectorAll("video").forEach(x => x.pause());
      clearTimeout(autoTimer);
      if (auto) autoTimer = setTimeout(() => show((cur + 1) % ORDER.length), DUR);
    }
    function stopAuto() { auto = false; started = true; clearTimeout(autoTimer); tabs.forEach(t => t.classList.remove("run")); }
    tabs.forEach((t, i) => t.addEventListener("click", () => { stopAuto(); show(i); }));
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !started) { started = true; show(0); }
      else if (!e.isIntersecting && auto) clearTimeout(autoTimer);
      else if (e.isIntersecting && auto) show(cur);
    }, { threshold: .3 }).observe(app);
  })();

  // Programare call: clientul alege pachetul, ziua și ora; cererea ajunge pe email (formularul de contact Shopify)
  const form = document.getElementById("orderForm");
  const $ = id => document.getElementById(id);
  const val = id => $(id).value.trim();
  const orderModal = $("orderModal");
  function openOrder(plan) {
    if (plan) form.plan.value = plan;
    orderModal.classList.add("open");
    document.body.classList.add("locked");
  }
  function closeOrder() {
    orderModal.classList.remove("open");
    document.body.classList.remove("locked");
  }
  document.querySelectorAll("[data-plan]").forEach(a => a.addEventListener("click", e => {
    e.preventDefault(); openOrder(a.dataset.plan);
  }));
  $("orderClose").onclick = closeOrder;
  // „/#comanda” (ex. din contul clientului) deschide direct programarea call-ului
  const callFromHash = () => { if (location.hash === "#comanda") { history.replaceState(null, "", location.pathname); openOrder("Growth"); } };
  callFromHash();
  addEventListener("hashchange", callFromHash);
  orderModal.addEventListener("click", e => { if (e.target === orderModal) closeOrder(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && orderModal.classList.contains("open")) closeOrder(); });

  // Ziua și ora call-ului: luni–vineri, 15:00–19:00 din 15 în 15 minute; sloturile ocupate vin de la server
  const API = "https://cui.scrollstop.ro";
  const pick = { date: "", time: "" };
  const romaniaToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Bucharest" }).format(new Date());
  function renderDays() {
    const box = $("dayPick"); box.innerHTML = "";
    const d = new Date(romaniaToday() + "T12:00:00Z");
    let added = 0;
    while (added < 10) {
      const wd = d.getUTCDay();
      if (wd !== 0 && wd !== 6) {
        const iso = d.toISOString().slice(0, 10);
        const b = document.createElement("button");
        b.type = "button"; b.dataset.date = iso; b.setAttribute("role", "radio");
        b.innerHTML = `<span>${d.toLocaleDateString("ro-RO", { weekday: "short", timeZone: "UTC" })}</span><b>${d.getUTCDate()}</b><span>${d.toLocaleDateString("ro-RO", { month: "short", timeZone: "UTC" })}</span>`;
        b.onclick = () => selectDay(iso);
        box.appendChild(b); added++;
      }
      d.setUTCDate(d.getUTCDate() + 1);
    }
  }
  async function selectDay(iso) {
    pick.date = iso; pick.time = "";
    $("dayPick").querySelectorAll("button").forEach(b => { const on = b.dataset.date === iso; b.classList.toggle("on", on); b.setAttribute("aria-checked", on); });
    const grid = $("slotGrid");
    grid.innerHTML = `<p class="slot-msg">Se încarcă orele libere…</p>`;
    try {
      const r = await fetch(`${API}/slots?date=${iso}`);
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      if (pick.date !== iso) return;
      const free = d.slots.filter(x => x.free).length;
      grid.innerHTML = free ? "" : `<p class="slot-msg">Nu mai sunt ore libere în ziua asta. Alege altă zi.</p>`;
      if (free) d.slots.forEach(x => {
        const b = document.createElement("button");
        b.type = "button"; b.textContent = x.time; b.disabled = !x.free; b.setAttribute("role", "radio");
        if (!x.free) b.title = "Ocupat";
        b.onclick = () => { pick.time = x.time; grid.querySelectorAll("button").forEach(y => { y.classList.toggle("on", y === b); y.setAttribute("aria-checked", y === b); }); };
        grid.appendChild(b);
      });
    } catch (e) {
      grid.innerHTML = `<p class="slot-msg">${e.message || "Nu am putut încărca orele. Încearcă din nou."}</p>`;
    }
  }
  renderDays();

  const showThanks = () => {
    form.hidden = true;
    const sent = $("sent");
    sent.innerHTML = `<strong>Mulțumim!</strong> Call-ul e programat ${pick.whenText || ""}. Te sunăm noi la numărul lăsat.`;
    sent.style.display = "block";
    form.after(sent);
  };

  form.addEventListener("submit", e => {
    e.preventDefault();
    const err = $("payErr"); err.textContent = "";
    if (!val("f-name")) { err.textContent = "Scrie-ți numele."; $("f-name").focus(); return; }
    const phone = val("f-phone").replace(/[^\d+]/g, "");
    if (!val("f-email") || !$("f-email").checkValidity()) { err.textContent = "Adresa de email nu pare corectă."; $("f-email").focus(); return; }
    if (phone.replace(/\D/g, "").length < 9) { err.textContent = "Numărul de telefon nu pare corect."; $("f-phone").focus(); return; }
    if (!pick.date) { err.textContent = "Alege ziua call-ului."; return; }
    if (!pick.time) { err.textContent = "Alege ora call-ului."; return; }

    const btn = $("f-submit");
    btn.disabled = true; btn.textContent = "Se trimite…";
    // cererea devine o comandă (draft order) în Shopify, prin serviciul nostru de pe cui.scrollstop.ro
    fetch("https://cui.scrollstop.ro/lead", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ plan: form.plan.value, name: val("f-name"), email: val("f-email"), phone: val("f-phone"), date: pick.date, time: pick.time, website: val("f-website") }),
    }).then(r => r.json().then(d => ({ ok: r.ok, d })))
      .then(({ ok, d }) => { if (!ok) throw new Error(d.error); pick.whenText = `${d.when}, la ora ${d.time}`; showThanks(); })
      .catch(e2 => {
        err.textContent = e2.message || "Nu am putut trimite cererea. Încearcă din nou.";
        if (pick.date) selectDay(pick.date);   // reîncarcă orele (poate s-a ocupat între timp)
        btn.disabled = false; btn.textContent = "Programează call-ul →";
      });
  });


  // Nav background + reveal on scroll
  const nav = document.getElementById("nav");
  addEventListener("scroll", () => nav.classList.toggle("scrolled", scrollY > 20), { passive: true });
  const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }), { threshold: .12 });
  document.querySelectorAll(".reveal").forEach(el => io.observe(el));

// player clip poveste
(() => {
  const box = document.querySelector(".story-video"); if (!box) return;
  const v = box.querySelector("video");
  const fill = box.querySelector(".sv-fill"), time = box.querySelector(".sv-time"), track = box.querySelector(".sv-track");
  const fmt = s => Math.floor(s / 60) + ":" + String(Math.floor(s % 60)).padStart(2, "0");
  const toggle = () => v.paused ? v.play() : v.pause();
  const sync = () => {
    box.toggleAttribute("data-paused", v.paused);
    box.querySelectorAll("button").forEach(b => b.setAttribute("aria-label", v.paused ? "Pornește clipul" : "Pune pauză"));
  };
  box.querySelectorAll("button").forEach(b => b.addEventListener("click", e => { e.stopPropagation(); toggle(); }));
  v.addEventListener("click", toggle);
  v.addEventListener("play", sync); v.addEventListener("pause", sync); v.addEventListener("ended", sync);
  v.addEventListener("timeupdate", () => { fill.style.width = (v.currentTime / v.duration * 100 || 0) + "%"; time.textContent = fmt(v.currentTime); });
  v.addEventListener("loadedmetadata", () => { time.textContent = fmt(v.duration); });
  track.addEventListener("click", e => { const r = track.getBoundingClientRect(); v.currentTime = (e.clientX - r.left) / r.width * v.duration; });
})();
